export const colunas = [
  {
    title: "Nome",
    dataIndex: "ContatoNome",
    key: "ContatoNome",
  },
  {
    title: "Email",
    dataIndex: "Email",
    key: "Email",
  },
  {
    title: "Tel. Escritorio",
    dataIndex: "TelefoneEscritorio",
    key: "TelefoneEscritorio",
  },
  {
    title: "CodigoABS",
    dataIndex: "CodigoABS",
    key: "CodigoABS",
  },
  {
    title: "Nome do Cliente",
    dataIndex: "ClienteNome",
    key: "ClienteNome",
  },
];
